<script setup lang="ts">
// Wartungsmeldung anstelle der Anwendung. Steuerung über cos-config.json,
// siehe shared/config/maintenance.ts.
import { computed } from "vue";

const props = defineProps<{
  message: string;
  end?: Date;
}>();

const WEBSITE_URL = "https://www.energis-netzgesellschaft.de/";

const endText = computed(() =>
  props.end
    ? props.end.toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }) + " Uhr"
    : ""
);
</script>

<template>
  <section class="maintenance-notice text-center mx-auto py-4" role="status">
    <h1 class="h3 mb-3">Wartungsarbeiten</h1>
    <p class="maintenance-notice__message">{{ message }}</p>
    <p v-if="endText">
      Voraussichtlich wieder erreichbar ab <strong>{{ endText }}</strong>.
    </p>
    <a :href="WEBSITE_URL" class="btn btn-primary mt-3">Zur Website</a>
  </section>
</template>

<style scoped>
.maintenance-notice {
  max-width: 36rem;
}
/* Zeilenumbrüche aus cos-config.json ("\n") sichtbar lassen. */
.maintenance-notice__message {
  white-space: pre-line;
}
</style>
